/** The src:172 page_name every owner-screen click reports under (the 198 pageName comes from the route). */
export const PROFILE_LINKS_PAGE = { page_name: 'profile_links' as const };

/** The visitor's `/profile-thread` opener. */
export const PROFILE_THREAD_PAGE = { page_name: 'profile_thread_open' as const };

/** The public `/me/` page (src:172 page_name; its 198 pageName is `profile_link` from the route). */
export const PROFILE_LINK_PAGE = { page_name: 'profile_link' as const };
